var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-dashboard-info"},[_c('div',{staticClass:"page-dashboard-info__form"},[_c('page-dashboard-info-user')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }